import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slice/uiSlice';
import controlReducer from './slice/controlSlice';
import cartReducer from './slice/cartSlice';
import dataReducer from './slice/dataSlice';
import toastReducer from './slice/toastSlice';
import hintReducer from './slice/hintSlice';
import toolReducer from './slice/toolSlice';

const store = configureStore({
  reducer: {
    ui: uiReducer,
    control: controlReducer,
    cart: cartReducer,
    data: dataReducer,
    toast: toastReducer,
    hint: hintReducer,
    tool: toolReducer,
  },
});

export default store;
